export default {
  PersonalCenter: '个人中心',
  MemberManage: '成员管理',
  MemberGroupManage: '成员组管理',
  RightsManage: '权限管理',
  WorkBench: '工作台',
  TaskHall: '任务管理',
  project: '项目管理',
  SystemSettings: '系统设置',
  teamInfo: '团队信息',
  authority: '权限管理',
  bankCardAccount: '银行卡账户',
  mailingAddress: '邮寄地址',
  DoingTask: '在办任务',
  Team: '团队',
  Financ: '财务',
  Riskloan: '风险投',
  ClueTask: '线索发现任务',
  PublicTask: '公共任务',
  DesignateTask: '指派任务',
  CaseTask: '案件打击任务',
  PublicCase: '公共案件',
  DesignateCase: '指派案件',
  Clue: '线索管理',
  Case: '案件管理',
  MyTask: '我的任务',
  AllTask: '全部任务',
  MyResult: '我的线索',
  AllResult: '全部线索',
  MyCase: '我管理的',
  CivilCase: '民事案件',
  ClueReport: '线索报审',
  AdministrativeCase: '行政案件',
  CriminalCase: '刑事案件',
  Inprogress: '进行中',
  Ended: '已结束',
  AllCases: '全部案件',
  AwaitAllocationCase: '待分配案件',
  MyTransactionCase: '我的出售案件',
  Processing: '出售中',
  Transacted: '已出售',
  AllTransactionCase: '全部出售案件',
  TeamManagement: '人员管理',
  JobPermissions: '职务权限',
  MyCenter: '个人中心',
  ResetPwd: '修改密码',
  Exit: '退出',
  Name: '姓名',
  Sex: '性别',
  Duties: '职务',
  Account: '账号',
  Mail: '电子邮箱',
  Mobile: '手机',
  Operating: '操作',
  AddEmployee: '新增员工',
  editIcon: '编辑',
  prohibitIcon: '禁用',
  resetIcon: '重置密码',
  enableIcon: '启用',
  'name/account/tel': '姓名/账号/手机',
  property: {
    'E': '法定代表人',
    'I': '经营者'
  },
  isEnable: {
    'Y': '启用',
    'N': '禁用'
  },
  cancel: '取消',
  reset: '重置',
  sure: '确定',
  forbidUserModal: '确定停用用户吗？',
  resetModal: '确定要重置密码吗？',
  enableModal: '确定启用用户吗？',
  BatchEnableList: {
    'Y': '批量启用',
    'N': '批量禁用'
  },
  role: {
    'All': '全部'
  },
  lawyerList: {
    'lawyer': '律师',
    'not-lawyer': '非律师'
  },
  'identity-information': '身份',
  certificateType: {
    'IC': '身份证',
    'PP': '护照'
  },
  'ID-type': '证件类型',
  tort_type: {
    'E_EC': '电商平台',
    'S_ST': '实体店铺',
    'S_FA': '工厂',
    'S_OT': '其他',
    'E_WL': '网页链接'
  },
  ec_channel: {
    'TT': '淘宝',
    'TS': '淘特',
    'TM': '天猫',
    'AL': '阿里巴巴',
    'JD': '京东',
    'SN': '苏宁',
    'YH': '1号店',
    'PD': '拼多多',
    'OT': '其他',
    'DY': '抖音'
  }
}




// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js